export default "__VITE_ASSET__DyA4wkQ3__"